
import SectionOne from "../SectionOne/SectionOne";

function Home() {
  return (
    <div>
      <SectionOne />

    </div>
  );
}
export default Home;
